import clsx from 'clsx';
import { FC, useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import About from '../components/About';
import BookingList from '../components/BookingList';
import LoggedOut from '../components/BookingList/LoggedOut';
import NoBooking from '../components/BookingList/NoBooking';
// import ChatThreadList from '../components/ChatThreadList';
// import PastChatsCTA from '../components/ChatThreadList/PastChatsCTA';
import DowntimeAlert from '../components/DowntimeAlert';
import Header from '../components/Header';
import BottomNavigationBar from '../components/Navigation/Bottom';
import HeaderNavigation from '../components/Navigation/Header';
import ServiceList from '../components/ServiceList';
import { Client } from '../enums/common';
// import useNavigateWithTransition from '../hooks/useNavigateWithTransition';
import useUserInfo from '../hooks/useUserInfo';
import { isMobile } from '../utils/common';
import { getCookieHelpers } from '../utils/cookie';
import { isForeignEnvironment, pwaQuit, shouldPwaQuit } from '../utils/pwa';
import PageLoader from '../components/Loader/PageLoader';

const Helpcenter: FC = () => {
    const { isUserLoggedIn } = useUserInfo();
    const [searchParams] = useSearchParams();
    const [noBooking, setNoBooking] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    // const navigate = useNavigateWithTransition();
    const hideHeader = !isForeignEnvironment() || searchParams.get('hideBackButton')?.toLowerCase() === 'true';
    const showNavbar = getCookieHelpers().getCookie('clientId') === Client.IXIMWEB;
    const isMob = isMobile();

    const renderSidePanel = useCallback(() => {
        if (!isUserLoggedIn) return <LoggedOut />;
        if (noBooking) return <NoBooking />;
        // return <ChatThreadList />;
        return null;
    }, [isUserLoggedIn, noBooking]);

    useEffect(() => {
        if (pageLoading) {
            setTimeout(() => {
                setPageLoading(false);
            }, 8000);
        }
    }, [pageLoading]);

    // Reset loading state when page is restored from cache (back/forward navigation)
    useEffect(() => {
        const handlePageShow = (event: PageTransitionEvent) => {
            // If page was restored from cache, reset loading state
            // This handles the case when user clicks back button and browser restores cached page
            if (event.persisted) {
                setPageLoading(false);
            }
        };

        window.addEventListener('pageshow', handlePageShow);

        return () => {
            window.removeEventListener('pageshow', handlePageShow);
        };
    }, []);

    if (pageLoading) return <PageLoader />;

    if (isMob)
        return (
            <div className='flex flex-col min-h-screen bg-charcoal-40'>
                {!hideHeader && <Header onBack={shouldPwaQuit() ? pwaQuit : undefined} />}
                <div className='flex-1 flex flex-col gap-10 bg-charcoal-40 overflow-y-auto'>
                    <div className='bg-charcoal-40'>
                        <BookingList setPageLoading={setPageLoading} />
                    </div>
                    <DowntimeAlert />
                    {/* {isUserLoggedIn && <ChatThreadList />} */}
                    <div className='col-span-2 flex flex-col gap-30'>
                        <ServiceList />
                    </div>
                    {/* {isUserLoggedIn && (
                        <div className='p-20 bg-white'>
                            <PastChatsCTA onClick={() => navigate('/conversations', { type: 'forward' })} />
                        </div>
                    )} */}
                    <div className={clsx(showNavbar && 'pb-[5rem]')}>
                        <About />
                    </div>
                    {showNavbar && <BottomNavigationBar />}
                </div>
            </div>
        );

    return (
        <div className='flex flex-col min-w-desktop-min'>
            <HeaderNavigation />
            <div className='bg-charcoal-40'>
                <BookingList setNoBooking={setNoBooking} setPageLoading={setPageLoading} />
            </div>
            <div className='grid grid-cols-3 gap-20 w-full max-w-desktop-max mx-auto pt-30 px-30'>
                <div className='col-span-2 flex flex-col gap-30'>
                    <DowntimeAlert />
                    <ServiceList />
                    <About />
                </div>
                {renderSidePanel()}
            </div>
        </div>
    );
};

export default Helpcenter;
